import React, { useEffect, useState } from 'react';
import Chart from 'chart.js/auto';
import { BsQuestionCircle, BsX } from 'react-icons/bs';
import { Carousel, Container, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { decrypt, encrypt } from '../utils/crypto';
import { useNavigate, useParams } from 'react-router-dom';
import TeamPerformanceModal from './teamPerformanceModal';
import moment from 'moment';
import TeamPerformanceLoder from '@/components/loder/teamParformLoder';
import { constant } from '@/utils/constant';

const TeamPerformance = ({ isLoggedIn, socket }) => {
	const param = useParams();
	const [performModal, setPerformModal] = useState(false);
	const [data, setData] = useState([]);
	const sessionData = data || {};
	const session = sessionData?.session || {};
	const sessionDate = session && session?.session_date;
	const navigate = useNavigate();
	const [gameData, setGameData] = useState();
	const [teamName, setTeamName] = useState();
	const [singleActivityCount, setSingleActivityCount] = useState();
	const [summaryData, setSummaryData] = useState(null);
	const [activeRoundIndex, setActiveRoundIndex] = useState(0);
	// State to manage button selection and its value range
	const [buttonArray, setbuttonArray] = useState([
		{ text: 'First-time', selected: true, value: [5, 12] },
		{ text: 'Experienced', selected: false, value: [1, 3.5] },
	]);

	useEffect(() => {
		if (!param?.id || !socket) return;
		const sessionId = Number(decrypt(param.id));

		socket.emit('fetch-single-session-data', { id: sessionId });
		socket.on('fetch-single-session-data', (response) => {
			if (response.status === true && Number(response.data.session.id) === sessionId) {
				setData(response.data);
			}
			socket.off('fetch-single-session-data');
		});

		socket.emit('fetch-team-performance-all-rounds', { session_id: sessionId });
		socket.on('team-performance-all-rounds', (response) => {
			if (response.status === true && Array.isArray(response.data)) {
				setSummaryData(response.data);
				// Set active round to the last round by default
				const meta = [...new Set(response.data.map((row) => Number(row.retry_count ?? 0)))].sort((a, b) => a - b);
				if (meta.length > 0) {
					setActiveRoundIndex(meta.length - 1);
				}
			} else {
				setSummaryData([]);
			}
			socket.off('team-performance-all-rounds');
		});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Group by retry_count: unique rounds in ascending order
	const roundsMeta = summaryData?.length
		? [...new Set(summaryData.map((row) => Number(row.retry_count ?? 0)))].sort((a, b) => a - b)
		: [];
	const activeRetry = roundsMeta[activeRoundIndex] ?? roundsMeta[0];
	const roundSlice =
		summaryData?.filter((row) => Number(row.retry_count ?? 0) === activeRetry) ?? [];

	const transformedArray = roundSlice.map((row) => row.team_name ?? '');
	const teamParform = roundSlice.map((row) => ({
		activity: row.activity || {},
		teamCost: Number(row.team_cost) || 0,
		teamQualityError: Number(row.team_quality_error) || 0,
		blendedScore: Number(row.blended_score) ?? 0,
	}));
	const getTeamactivity = roundSlice.map((row) => ({
		...(row.room_activity || {}),
		noOfHoursNotComplete: Number(row.no_of_hours_not_complete) || 0,
	}));
	const blendedScores = roundSlice.map((row) => String(row.blended_score ?? ''));

	const isChrome =
		/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

	const yourDataArray = blendedScores;
	const maxValueInData = yourDataArray.length ? Math.max(...yourDataArray.map(Number).filter((n) => !Number.isNaN(n))) : 0;

	useEffect(() => {
		if (roundsMeta.length > 0 && activeRoundIndex >= roundsMeta.length) {
			setActiveRoundIndex(0);
		}
	}, [roundsMeta.length, activeRoundIndex]);

	// Handle button state changes
	const handleButtonState = (index, value) => {
		let temp = buttonArray;
		temp = temp.map((val, ind) => {
			if (ind === index) {
				val.selected = !val.selected;
			} else {
				val.selected = false;
			}
			return val;
		});
		setbuttonArray([...temp]);
	};

	useEffect(() => {
		if (roundSlice?.length) {
			// Chart setup (driven by current round slice)
			const data = {
				labels: transformedArray,
				datasets: [
					{
						data: blendedScores,
						backgroundColor: [
							'rgba(118, 166, 127, 1)',
							'rgba(213, 104, 103, 1)',
							'rgba(91, 192, 190, 1)',
							'rgba(233, 196, 106, 1)',
							'rgba(100, 134, 188, 1)',
							'rgba(244, 162, 97, 1)',
						],
						// borderColor: 'rgba(75, 192, 192, 1)',
						borderWidth: 2,
						borderSkipped: 'bottom',
						borderRadius: 5,
					},
				],
			};
			// Additional data for horizontal scrollbar
			const data2 = {
				labels: [],
				datasets: [
					{
						label: 'Weekly Sales',
						data: [],
					},
				],
			};

			// Chart configuration
			const config = {
				type: 'bar',
				data,
				options: {
					maintainAspectRatio: false,
					layout: {
						padding: {
							top: 10,
						},
					},
					onClick: (event, elements) => {
						if (elements && elements.length > 0) {
							performModalShow(elements);
						}
					},
					scales: {
						y: {
							max:
								maxValueInData !== 0
									? Math.ceil(maxValueInData / 5) * 5
									: Math.ceil(15 / 5) * 5, // Round up  5
							beginAtZero: true,
							ticks: {
								stepSize: 1,
								max:
									maxValueInData !== 0
										? Math.ceil(maxValueInData / 5) * 5
										: Math.ceil(15 / 5) * 5,
								suggestedMax:
									maxValueInData !== 0
										? Math.ceil(maxValueInData / 5) * 5
										: Math.ceil(15 / 5) * 5,
								callback: function (value, index, values) {
									return index % 5 === 0 ? value : '';
								},
								display: false,
							},

							grid: {
								drawTicks: false,
								color: '#404040',
								drawOnChartArea: true,
								ticks: {
									color: [
										'rgba(118, 166, 127, 1)',
										'rgba(213, 104, 103, 1)',
										'rgba(91, 192, 190, 1)',
										'rgba(233, 196, 106, 1)',
										'rgba(100, 134, 188, 1)',
										'rgba(244, 162, 97, 1)',
									],
								},
							},
						},
						x: {
							border: { color: 'white' },
							ticks: {
								color: [
									'rgba(118, 166, 127, 1)',
									'rgba(213, 104, 103, 1)',
									'rgba(91, 192, 190, 1)',
									'rgba(233, 196, 106, 1)',
									'rgba(100, 134, 188, 1)',
									'rgba(244, 162, 97, 1)',
								],
								font: {
									weight: '700',
									size: '14px',
								},
								callback: (value, index) => {
									const label = transformedArray[index];
									return (label ?? '').trim();
								},
							},
						},
					},
					plugins: {
						legend: {
							display: false,
						},
						tooltip: {
							enabled: false, // Disable default tooltip as per Figma
						},
						datalabels: {
							anchor: 'center', // Put label inside bar
							align: 'center',
							color: 'black',
							font: {
								weight: '700',
								size: '16px',
								family: 'Futura PT',
							},
							formatter: (value, context) => {
								return value > 0 ? value : null;
							},
						},
					},
					maxBarThickness: 100, // Prevent bars from being too wide
					categoryPercentage: 0.8,
					barPercentage: 0.9,
				},
				plugins: [
					{
						// Plugin to highlight a specific range after drawing
						afterDraw: function (chart) {
							const ctx = chart.ctx;
							const xAxis = chart.scales['x'];
							const yAxis = chart.scales['y'];
							const rangeStart = yAxis.getPixelForValue(
								buttonArray.find(item => item.selected)?.value[0] || 0
							);
							const rangeEnd = yAxis.getPixelForValue(
								buttonArray.find(item => item.selected)?.value[1] || 0
							);
							ctx.save();
							ctx.canvas.style.zIndex = 10;
							ctx.fillStyle = 'rgba(253, 207, 118, .20)';
							ctx.fillRect(
								xAxis.left,
								rangeStart,
								xAxis.width,
								rangeEnd - rangeStart
							);
							ctx.restore();
						},
					},
					ChartDataLabels,
				],
			};

			// Additional configuration for horizontal scrollbar
			const config2 = {
				type: 'bar',
				data2,
				options: {
					maintainAspectRatio: false,
					layout: {
						padding: {
							// bottom: ,
						},
					},
					scales: {
						x: {
							color: 'white',
							border: { color: 'white' },
							grid: {
								color: 'white',
							},
						},
						y: {
							max:
								maxValueInData !== 0
									? Math.ceil(maxValueInData / 5) * 5
									: Math.ceil(15 / 5) * 5,
							beginAtZero: true,
							ticks: {
								stepSize: 1,
								max:
									maxValueInData !== 0
										? Math.ceil(maxValueInData / 5) * 5
										: Math.ceil(15 / 5) * 5, // Round up  5
								suggestedMax:
									maxValueInData !== 0
										? Math.ceil(maxValueInData / 5) * 5
										: Math.ceil(15 / 5) * 5,
								callback: function (value, index, values) {
									return index % 5 === 0 ? value : '';
								},
								minor: {
									stepSize: 0.5,
								},
								font: {
									weight: 500,
								},
								color: 'white',
							},
							afterFit: ctx => {
								ctx.width = 34.4;
							},
							border: { color: 'white' },
							grid: {
								color: context => {
									const tickValue = context.tick.value;
									return tickValue % 5 === 0 ? 'white' : '#404040';
								},
							},
						},
					},
					plugins: {
						legend: {
							display: false,
						},
						tooltip: {
							display: false,
						},
						datalabels: {
							anchor: 'top',
							align: 'top',
							color: 'white',
							font: {
								weight: '700',
								size: '18px',
							},
							formatter: (value, context) => {
								if (value > 0) {
									return value;
								} else {
									return null;
								}
							},
						},
					},
				},
				plugins: [ChartDataLabels],
			};

			// render init block
			const myChart = new Chart(document.getElementById('myChart'), config);
			const myChart2 = new Chart(document.getElementById('myChart2'), config2);
			const box = document.getElementById('box');

			// Adjust the width based on the number of bars - more responsive approach
			const barlength = myChart.data.labels.length;
			if (barlength > 7) {
				const minBarWidth = 80; // Minimum width per bar
				const calculatedWidth = barlength * minBarWidth;
				box.style.width = `${calculatedWidth}px`;
			} else {
				box.style.width = '100%';
			}

			return () => {
				myChart.destroy();
				myChart2.destroy();
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [buttonArray, summaryData, activeRoundIndex]);

	// tooltip content
	const renderTooltip = props => (
		<Tooltip
			className='tooltip-light'
			id='button-tooltip'
			{...props}
		>
			{constant?.teamParform}
		</Tooltip>
	);

	const performModalShow = elements => {
		const targetIndex = elements && elements[0]?.index;
		const teamPerform = teamParform[targetIndex];
		const teamIndex = transformedArray[targetIndex];
		const teamActivity = getTeamactivity[targetIndex];
		setSingleActivityCount(teamActivity);
		setTeamName(teamIndex);
		setGameData(teamPerform);
		setPerformModal(!performModal);
	};

	return (
		<>
			{summaryData?.length > 0 ? (
				<div className='bg-black'>
					{isLoggedIn && (
						<BsX
							onClick={() => {
								navigate(`/group/${encrypt(String(session?.id))}`);
							}}
							className='end-2 top-2 text-2xl position-absolute text-white'
						/>
					)}
					<div className='min-h-screen text-center text-white py-10 chart-scroll team-performance-page'>
						<Container>
							<p className='pb-4 text-uppercase ls-widest text-17'>
								{session && session?.name} (
								{session && moment(sessionDate).format('MMMM D, YYYY')})
							</p>
							<h1 className='text-futura text-white font-semibold mb-6'>
								{roundsMeta.length > 0
									? `Round ${activeRetry + 1} ${constant?.teamScore}`
									: constant?.teamScore}
							</h1>
							<p className='font-bold mb-4 text-15'>
								{constant?.showScore}
								<OverlayTrigger
									placement='bottom-start'
									delay={{ show: 250, hide: 400 }}
									overlay={renderTooltip}
								>
									<span>
										<BsQuestionCircle className='ms-1' />
									</span>
								</OverlayTrigger>
							</p>
							<Form className='hstack flex-wrap gap-4 justify-content-center mb-6'>
								{buttonArray?.map((item, index) => {
									return (
										<Form.Check
											key={index}
											className='yellow-check'
											type={'checkbox'}
											id={index+1}
										>
											<Form.Check.Input
												checked={item?.selected}
												onChange={() => handleButtonState(index, item.value)}
												type='checkbox'
											/>
											<Form.Check.Label className='text-white font-regular text-sm'>
												{item.text}
											</Form.Check.Label>
										</Form.Check>
									);
								})}
							</Form>

							<div className='team-performance-carousel-wrap position-relative'>
								{roundsMeta.length > 1 ? (
									<>
										<div
											className='position-absolute top-0 start-0 end-0 d-flex justify-content-center align-items-start team-performance-carousel-chart-layer'
										>
											<div className='team-performance-chart-container'>
												<div
													className='team-performance-y-axis'
												>
													<canvas
														style={{
															marginBottom: `${isChrome === false ? '37px' : '45px'}`,
														}}
														id='myChart2'
													></canvas>
												</div>
												<div
													className='team-performance-chart-scroll chart-scroll'
												>
													<div
														id='box'
														style={{ height: '500px' }}
													>
														<canvas id='myChart'></canvas>
													</div>
												</div>
											</div>
										</div>
										<Carousel
											activeIndex={activeRoundIndex}
											onSelect={(index) => setActiveRoundIndex(index)}
											interval={null}
											indicators
											controls={roundsMeta.length > 1}
											prevIcon={
												activeRoundIndex > 0 ? (
													<div className='custom-carousel-control'>
														<div className='control-icon-box'>
															<span className='carousel-control-prev-icon' aria-hidden='true' />
														</div>
														<span className='control-label'>Round {roundsMeta[activeRoundIndex - 1] + 1}</span>
													</div>
												) : null
											}
											nextIcon={
												activeRoundIndex < roundsMeta.length - 1 ? (
													<div className='custom-carousel-control'>
														<div className='control-icon-box'>
															<span className='carousel-control-next-icon' aria-hidden='true' />
														</div>
														<span className='control-label'>Round {roundsMeta[activeRoundIndex + 1] + 1}</span>
													</div>
												) : null
											}
											wrap={false}
											className='team-performance-carousel position-relative'
										>
											{roundsMeta.map((retry) => (
												<Carousel.Item key={retry}>
													<div
														className='team-performance-carousel-slide'
														style={{ minHeight: '550px' }}
														aria-hidden='true'
													/>
												</Carousel.Item>
											))}
										</Carousel>
									</>
								) : (
									<div className='team-performance-chart-container'>
										<div
											className='team-performance-y-axis'
										>
											<canvas
												style={{
													marginBottom: `${isChrome === false ? '37px' : '45px'}`,
												}}
												id='myChart2'
											></canvas>
										</div>
										<div
											className='team-performance-chart-scroll chart-scroll'
										>
											<div
												id='box'
												style={{ height: '500px' }}
											>
												<canvas id='myChart'></canvas>
											</div>
										</div>
									</div>
								)}
							</div>
							<p className='text-white text-start text-xs mt-10'>
								{constant?.gameMessage}{' '}
								<a
									className='text-secondary text-no-decoration font-regular ls-wider text-break'
									target='_blank'
									rel='noreferrer'
									href='https://fridaynightattheer.com/'
								>
									{constant?.fridayNightEmail}
								</a>
							</p>
						</Container>
					</div>
				</div>
			) : (
				<TeamPerformanceLoder />
			)}
			{performModal ? (
				<TeamPerformanceModal
					gameData={gameData}
					show={performModal}
					teamName={teamName}
					singleActivityCount={singleActivityCount}
					hide={performModalShow}
					sessionData={sessionData}
					game_complete_status={false}
				/>
			) : null}
		</>
	);
};

export default TeamPerformance;
